import { useEffect } from 'react';

// Counts active locks so stacked overlays (e.g. the mobile menu opening the
// search palette) restore the body's original overflow only once all close.
let activeLocks = 0;
let previousOverflow = '';

const useScrollLock = (active) => {
  useEffect(() => {
    if (!active) return undefined;
    if (activeLocks === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    activeLocks += 1;
    return () => {
      activeLocks -= 1;
      if (activeLocks === 0) document.body.style.overflow = previousOverflow;
    };
  }, [active]);
};

export default useScrollLock;
